const photos = [
  "https://images.unsplash.com/photo-1782512990521-19c63a8b901e",
  "https://images.unsplash.com/photo-1782512990683-b5642faa82cd",
  "https://images.unsplash.com/photo-1782512992579-839aae7b2d4e",
  "https://images.unsplash.com/photo-1782441164509-bc3addf89ca7",
  "https://images.unsplash.com/photo-1774025124230-b99eb65121da",
  "https://images.unsplash.com/photo-1774025124285-0a26bc59eeb4",
  "https://images.unsplash.com/photo-1782441164401-bc4f2ecfce5f",
  "https://images.unsplash.com/photo-1782441164440-4005f61a0ed7",
  "https://images.unsplash.com/photo-1782441164448-c67ca7efbacc",
  "https://images.unsplash.com/photo-1782441164458-e466f50739ad",
  "https://images.unsplash.com/photo-1782441164464-472540620abd",
  "https://images.unsplash.com/photo-1782441164468-21031247f1df",
  "https://images.unsplash.com/photo-1774025124207-d8eeaec8ee24",
  "https://images.unsplash.com/photo-1782441164496-dc95dfcb5dd1",
  "https://images.unsplash.com/photo-1782441164524-b21a9eb6714f",
  "https://images.unsplash.com/photo-1782441164541-40d2a9879e7a",
  "https://images.unsplash.com/photo-1782441164551-72c16a2af444",
  "https://images.unsplash.com/photo-1782441164377-e75252426dfb",
  "https://images.unsplash.com/photo-1782441164625-3d0fddf80183",
  "https://images.unsplash.com/photo-1782512990477-cd814a3da3f6",
  "https://images.unsplash.com/photo-1782512990501-97e9c2d7b951",
  "https://images.unsplash.com/photo-1782512990518-930a3ff2f1e5",
];

// 1. Mapeamento das pré-seleções por índices
const SELECTIONS = {
  // hero: [0],                  // Apenas a primeira foto para o banner principal
  nav: [0, 3, 5, 6, 21], // Fotos de destaque
  // gallery: [4, 5, 6, 7],      // Fotos para a galeria interna
};

/**
 * Photo Factory
 * @param {Object} options
 * @param {'nav' | 'custom'} options.type - O tipo de pré-seleção
 * @param {number[]} [options.indexes] - Índices customizados se o tipo for 'custom'
 */
export default function photoFactory({ type, indexes = [] } = {}) {
  // Se não passar tipo nem índices customizados, retorna tudo
  if (!type && indexes.length === 0) {
    return photos;
  }

  // Se o tipo for 'custom', usa os índices passados na hora por parâmetro
  if (type === "custom") {
    return indexes.map((index) => photos[index]).filter(Boolean);
  }

  // Busca os índices mapeados no objeto SELECTIONS
  const targetIndexes = SELECTIONS[type];

  if (!targetIndexes) {
    console.warn(
      `Tipo de seleção "${type}" não encontrado. Retornando array vazio.`,
    );
    return [];
  }

  // Mapeia os índices para as URLs reais e remove valores undefined (caso o índice não exista)
  return targetIndexes.map((index) => photos[index]).filter(Boolean);
}
